export default "__VITE_ASSET__iJDmjs1k__"